export enum ProductSetType {
    UserDefined = 0,
    System      = 1
}
